import { EntityState } from "@ngrx/entity";
import {
  Acabado,
  CaracteristicaMaterial,
  ColorMaterial,
  Continente,
  DetalleStock,
  Disponibilidad,
  Espesor,
  Filter,
  Maestros,
  Material,
  RangoPrecio,
  Stock,
  UnidadMedida,
  TipoMaterial,
  UsoMaterial } from "../models";
import { UiState } from './ui.state';

export * from './adapters.state';
export * from './ui.state';

export interface ModuleState {
  maestros: {
    tipoMaterial: EntityState<TipoMaterial>,
    acabado: EntityState<Acabado>,
    usoMaterial: EntityState<UsoMaterial>,
    continente: EntityState<Continente>,
    colorMaterial: EntityState<ColorMaterial>,
    espesor: EntityState<Espesor>,
    disponibilidad: EntityState<Disponibilidad>,
    rangoPrecio: EntityState<RangoPrecio>,
    materiales: EntityState<Material>,
    caracteristicasMaterial: EntityState<CaracteristicaMaterial>,
    all: Maestros
  },
  selectedFilters: EntityState<Filter>,
  filters: EntityState<Filter>,
  stock: EntityState<Stock>,
  resultsCount: number,
  details: DetalleStock[],
  materialesSimilares: Material[],
  unidadMedida: UnidadMedida,
  ui: UiState
}
